import { Component, ElementRef, HostListener, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProfitabilityService } from '../../../incentives/services/profitability.service';
import { IBookmarkInfo } from '../../interfaces/bookmark-info';
import { BookmarkService } from '../../services/bookmark.service';
import { LoanDetailsListTracker } from '../loan-details-data';
import { LoanDetailsListOfLoansService } from '../loan-details-list-of-loans.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-loan-card-dialog',
    templateUrl: './loan-card-dialog.component.html',
    styleUrls: ['./loan-card-dialog.component.scss'],
})
export class LoanCardDialogComponent implements OnInit {
    loanNumber: string;
    bookmarked: boolean = false;
    listOfLoansTracker: LoanDetailsListTracker;

    disableNext: boolean = true;
    disablePrev: boolean = true;
    lastLOSUpdate: any = null;
    isOriginatedFromLoanProfitability: boolean;

    constructor(
        private _bookmarkService: BookmarkService,
        private listOfLoansService: LoanDetailsListOfLoansService,
        private profitabilityService: ProfitabilityService,
        private eRef: ElementRef,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.lastLOSUpdate = null;
        this.loanNumber = this.data.loanNumber;
        this.listOfLoansTracker = {
            index: 0,
            loanNumbers: [],
        };
        this.listOfLoansService.currentListOfLoans.subscribe((loansTracker) => {
            if (loansTracker) {
                this.listOfLoansTracker = loansTracker;
                this.disablePrev = this.listOfLoansTracker.index === 0;
                this.disableNext =
                    this.listOfLoansTracker.index ===
                    this.listOfLoansTracker.loanNumbers.length - 1;
            }
        });
    }

    ngOnInit(): void {
        this.loadBookmark();
        this.isOriginatedFromLoanProfitability =
            this.profitabilityService?.dialogParametrs?.isLoanProfitabilityDialog;
    }

    // Fetch loan bookmark value
    loadBookmark() {
        this._bookmarkService
            .getBookmarksByLoanNumber(this.loanNumber)
            .subscribe((bookmark: IBookmarkInfo) => {
                if (bookmark) {
                    this.bookmarked = bookmark.bookmark;
                }
            });
    }

    // Handle click event for bookmarking loan
    updateCardBookmark() {
        let currentBookmark = this.bookmarked;
        this.bookmarked = !this.bookmarked;

        this._bookmarkService
            .changeLoanBookmarkStatus(this.loanNumber, null, this.bookmarked)
            .subscribe((result) => {
                if (result < 1) {
                    this.bookmarked = currentBookmark;
                }
            });
    }

    navigateToPrevLoan() {
        if (!this.disablePrev) {
            this.listOfLoansTracker.index--;

            this.lastLOSUpdate = null;
            this.loanNumber = this.listOfLoansTracker.loanNumbers[this.listOfLoansTracker.index];
            this.disablePrev = this.listOfLoansTracker.index === 0;
            this.disableNext = false;

            this.bookmarked = false;
            this.loadBookmark();

            // Make sure URL updates with new loan number and keep existing query params for display options
            let queryParams = this.route.snapshot.queryParams;
            this.router.navigate([{ outlets: { modal: 'loanDetails/' + this.loanNumber } }], {
                queryParams: queryParams,
            });
        }
    }

    navigateToNextLoan() {
        if (!this.disableNext) {
            this.listOfLoansTracker.index++;
            this.disableNext =
                this.listOfLoansTracker.index === this.listOfLoansTracker.loanNumbers.length - 1;
            this.disablePrev = false;

            this.lastLOSUpdate = null;
            this.loanNumber = this.listOfLoansTracker.loanNumbers[this.listOfLoansTracker.index];

            this.bookmarked = false;
            this.loadBookmark();

            // Make sure URL updates with new loan number and keep existing query params for display options
            let queryParams = this.route.snapshot.queryParams;
            this.router.navigate([{ outlets: { modal: 'loanDetails/' + this.loanNumber } }], {
                queryParams: queryParams,
            });
        }
    }

    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.code == 'ArrowRight') {
            this.navigateToNextLoan();
        }

        if (event.code == 'ArrowLeft') {
            this.navigateToPrevLoan();
        }
    }

    updateLOS(event) {
        if (event && event.data) {
            this.lastLOSUpdate = event.data;
        } else {
            this.lastLOSUpdate = null;
        }
    }

    openLoanProfitabilityDialog() {
        this.profitabilityService.openLoanProfitabilityDialog();
    }
}
